import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel } from '../../shared/config';
import { PersonModel } from '../../person/models/person.model';
import { OrganizationAdminService } from '../models/organizationAdmin.service';
import { OrganizationAdminModel } from '../models/organizationAdmin.model';
import { OrganizationService } from '../../organization/models/organization.service';

@Component({
  selector: 'wego-add-organizationadmin',
  template: require('../views/add-organizationadmin-popup.component.html'),
  styles: [`.my-loading {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0%;
      right: 0%;
      text-align: center;
      z-index: 9999;
    }
    
    .my-loading .dimmer {
      position: absolute;
      top: 0;
      left: 0;
      background-color: #000;
      opacity: 0.5;
      width: 100%;
      height: 100%;
    }
    
    .my-loading .loading-bg {
      position: absolute;
      display: inline-block;
      top: 50%;
      left: -webkit-calc(50% - 40px);
      left: -moz-calc(50% - 40px);
      left: calc(50% - 40px);
      transform: translateY(-50%);
      padding: 22px;
      background-color: #fff;
      border-radius: 15px;
      text-align: center;
    }`]
})

export class AddOrganizationAdminPopupComponent implements OnInit, OnChanges {
  DataListModel: DataListModel;
  personList: PersonModel[];
  message: string;
  apiErrorMsg: string;
  urlPersonUpdate: string;
  isLoading: boolean;

  public organizationMasterHashId: string;
  private popupMsg: string;
  private module: string;
  private breadCrumbTitle: string;

  @Output('OnSuccessSelect') onSuccessSelect = new EventEmitter();
  @ViewChild('organizationAdminModal') public organizationAdminModal: any;
  @ViewChild('successPopup') public successPopup: any;

  constructor(private organizationAdminService: OrganizationAdminService
    , private organizationService: OrganizationService
    , private authService: AuthService
    , private router: Router
    , private translate: TranslateService) { }

  ngOnInit() {
    this.module = this.translate.instant('LblOrganizationAdmin');
    this.DataListModel = new DataListModel();
    this.DataListModel.searchField = ["userName", "firstName", "lastName"];
    this.urlPersonUpdate = this.authService.GetURL(ApplicationRouteURL.URL_PERSON_UPDATE);
    this.breadCrumbTitle = this.translate.instant('LblAddPage', [this.module]);
  }

  ngOnChanges(change: any) {
    console.log(change);
  }

  public show(): void {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.sortType = "";
    this.DataListModel.sortReverse = null;
    this.DataListModel.searchTerm = "";
    this.DataListModel.infoMessage = "";
    this.GetOrganizationAdminPersonList();
    this.organizationAdminModal.show();
  }

  public hide(): void {
    this.organizationAdminModal.hide();
  }

  private GetOrganizationAdminPersonList() {
    this.isLoading = true;
    this.organizationAdminService.GetPersonListByOrganizationId(this.organizationMasterHashId, this.DataListModel)
      .subscribe(
      res => {
        this.personList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  private select(personMasterHashId: string): void {
    this.isLoading = true;
    let model = new OrganizationAdminModel();
    model.personHashID = personMasterHashId;
    model.organizationMasterHashId = this.organizationMasterHashId;
    this.organizationAdminService.AddNewOrganizationAdmin(model)
      .subscribe(
      res => {
        this.popupMsg = this.translate.instant('LblRecordAddedSuccess', [this.module]);;
        this.OnSuccessSelect();
        this.isLoading = false;
        this.ShowSuccessPopup()

      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      },
      () => {
        this.organizationAdminModal.hide();
        this.isLoading = false;
      });
  }

  private OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetOrganizationAdminPersonList();
  }

  private OnSearch(event: any) {
    this.DataListModel.searchTerm = event.searchTerm;
    this.DataListModel.currentPage = 1;
    this.GetOrganizationAdminPersonList();
  }

  private OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetOrganizationAdminPersonList();
  };

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetOrganizationAdminPersonList();
  }
  private OnSuccessSelect() {
    this.onSuccessSelect.emit({ SuccessMessage: this.message })
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/organizationadmin/components/add-organizationadmin-popup.component.ts